module.exports = __webpack_public_path__ + "static/media/3.1 Bellevois Vorzustand.2671aa49.jpg";